import React from 'react';
import { Box, Typography, IconButton, Tooltip } from '@mui/material';
import AlignHorizontalLeftRoundedIcon from '@mui/icons-material/AlignHorizontalLeftRounded';
import AlignVerticalTopRoundedIcon from '@mui/icons-material/AlignVerticalTopRounded';

const SectionMenu = ({
  activeColumn,
  activeAlign,
  handleUpdateSectionColumns,
  handleUpdateSectionAlignment,
  sectionMenuOpenId,
}) => {
  return (
    <Box
      sx={{
        p: "0.5rem",
        display: "flex",
        flexDirection: "column",
        gap: "0.5rem",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "0.5rem",
        }}
      >
        <Typography
          variant="body2"
          sx={{ fontSize: "0.8rem", minWidth: "60px" }}
        >
          Columns:
        </Typography>
        <Box sx={{ display: "flex", gap: "0.3rem" }}>
          {[1, 2, 3].map((num) => (
            <IconButton
              key={num}
              size="small"
              variant="outlined"
              onClick={() => handleUpdateSectionColumns(sectionMenuOpenId, num)}
              sx={{
                borderRadius: "2rem",
                backgroundColor:
                  activeColumn === num ? "primary.main" : "transparent",
                color: activeColumn === num ? "#fff" : "inherit",
                border: "1px solid",
                borderColor: activeColumn === num ? "primary.main" : "#ccc",
                padding: "0.2rem 0.6rem",
                fontSize: "0.8rem",
                transition: " background-color 0.2s ease-in-out",
                "&:hover": {
                  backgroundColor:
                    activeColumn === num ? "primary.dark" : "#f5f5f5",
                },
              }}
            >
              {num}
            </IconButton>
          ))}
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "0.5rem",
        }}
      >
        <Typography
          variant="body2"
          sx={{ fontSize: "0.8rem", minWidth: "60px" }}
        >
          Alignment:
        </Typography>
        <Box sx={{ display: "flex", gap: "0.3rem" }}>
          {["top_to_bottom", "left_to_right"].map((align) => (
            <Tooltip
              key={align}
              title={align === "top_to_bottom" ? "Top to bottom" : "Left to right"}
              arrow
            >
              <IconButton
                size="small"
                variant="outlined"
                onClick={() => handleUpdateSectionAlignment(sectionMenuOpenId, align)}
                sx={{
                  borderRadius: "2rem",
                  backgroundColor:
                    activeAlign === align ? "primary.main" : "transparent",
                  color: activeAlign === align ? "#fff" : "inherit",
                  border: "1px solid",
                  borderColor: activeAlign === align ? "primary.main" : "#ccc",
                  padding: "0.2rem 0.6rem",
                  fontSize: "0.8rem",
                  transition: " background-color 0.2s ease-in-out",
                  "&:hover": {
                    backgroundColor:
                      activeAlign === align ? "primary.dark" : "#f5f5f5",
                  },
                }}
              >
                {align === "left_to_right" ? (
                  <AlignHorizontalLeftRoundedIcon sx={{ fontSize: "1rem" }} />
                ) : (
                  <AlignVerticalTopRoundedIcon sx={{ fontSize: "1rem" }} />
                )}
              </IconButton>
            </Tooltip>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default SectionMenu; 